import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
export default function useGetMailsForFolder(id) {
  return useQuery(['get-folder-mails', id], async () => {
    const response = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.MAILS_FOLDER, {
        id: id,
      })
    );
    return response?.data;
  });
}
